import { GridHeaders } from '@project-types/GridHeaders';
import { TradesDistrictReportGridData } from '@pages/reporting-pages/deliveries-trades-district/types/TradesDistrictReportGridData';



export const headersObject: GridHeaders<TradesDistrictReportGridData> = [
	{ label: 'ON Trade / OFF Trade', key: 'onOffTrade', width: '1fr' },
	{ label: 'Stát', key: 'country', width: '1fr' },
	{ label: 'Sales region', key: 'tradeCode', width: '1fr' },

	{ label: 'Total - Objem [hl]', key: 'total_volume', width: '1fr' },
	{ label: 'Total - Váha [t]', key: 'total_weight', width: '1fr' },
	{ label: 'Total - Váha vratky [t]', key: 'total_returnsWeight', width: '1fr' },
	{ label: 'Total - Počet objednávek', key: 'total_ordersCount', width: '1fr' },
	
	{ label: 'SD - Objem [hl]', key: 'sd_volume', width: '1fr' },
	{ label: 'SD - Váha [t]', key: 'sd_weight', width: '1fr' },
	{ label: 'SD - Váha vratky [t]', key: 'sd_returnsWeight', width: '1fr' },
	{ label: 'SD - Počet objednávek', key: 'sd_ordersCount', width: '1fr' },

	{ label: 'INT - Objem [hl]', key: 'int_volume', width: '1fr' },
	{ label: 'INT - Váha [t]', key: 'int_weight', width: '1fr' },
	{ label: 'INT - Váha vratky [t]', key: 'int_returnsWeight', width: '1fr' },
	{ label: 'INT - Počet objednávek', key: 'int_ordersCount', width: '1fr' },

	{ label: 'DD - Objem [hl]', key: 'dd_volume', width: '1fr' },
	{ label: 'DD - Váha [t]', key: 'dd_weight', width: '1fr' },
	{ label: 'DD - Váha vratky [t]', key: 'dd_returnsWeight', width: '1fr' },
	{ label: 'DD - Počet objednávek', key: 'dd_ordersCount', width: '1fr' },

	{ label: 'TD - Objem [hl]', key: 'td_volume', width: '1fr' },
	{ label: 'TD - Váha [t]', key: 'td_weight', width: '1fr' },
	{ label: 'TD - Váha vratky [t]', key: 'td_returnsWeight', width: '1fr' },
	{ label: 'TD - Počet objednávek', key: 'td_ordersCount', width: '1fr' },
]